// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: var(--boxx-modal-header-background, #01091a);
}

ion-header ion-toolbar {
  --min-height: var(--boxx-modal-toolbar-min-height, 64px);
  margin-top: var(--boxx-modal-toolbar-margin-top, 0px);
  margin-bottom: var(--boxx-modal-toolbar-margin-bottom, -2px);
  --padding-top: var(--boxx-modal-toolbar-padding-top, 0px);
  border-top-left-radius: var(--boxx-modal-toolbar-topleft-radius, 10px);
  border-top-right-radius: var(--boxx-modal-toolbar-topright-radius, 10px);
  --background: var(
    --boxx-modal-toolbar-background,
    var(--boxx-app-background, white)
  );
  color: var(--boxx-modal-toolbar-color, var(--ion-text-color));
}
ion-header ion-toolbar ::ng-deep ion-title {
  margin-left: var(--boxx-modal-title-margin-left, 16px) !important;
  padding: var(--boxx-modal-title-padding, 0px);
  font-size: var(--boxx-modal-title-font-size, 17px);
  font-weight: var(--boxx-modal-title-font-weight, 700);
}
ion-header ion-toolbar ion-buttons[slot=end] {
  margin-right: var(--boxx-modal-buttons-end-margin-right, 4px);
}
ion-header ion-toolbar #grabber {
  width: var(--boxx-modal-grabber-width, 36px);
  height: var(--boxx-modal-grabber-height, 5px);
  background: var(--boxx-modal-grabber-background, #c7c7cc);
  margin: var(--boxx-modal-grabber-margin, 0 auto);
  position: var(--boxx-modal-grabber-position, absolute);
  top: var(--boxx-modal-grabber-top, 7px);
  left: var(--boxx-modal-grabber-left, 15px);
  right: var(--boxx-modal-grabber-right, 0);
}

ion-content {
  height: var(--boxx-modal-content-height, 100%);
}

#searchbar-wrapper {
  --padding-start: 0px;
  --inner-padding-end: 0px;
}

ion-searchbar {
  margin-left: 0px;
  margin-right: 24px;
  padding: 0px 10px !important;
  margin-top: 18px;
}

ion-img {
  width: 100%;
}

#loadMoreButton {
  width: 100%;
}

.col-skeleton {
  height: 75px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/settings/components/pixabay-picker/pixabay-select.component.scss"],"names":[],"mappings":"AAAA;EACE,wDAAA;AACF;;AAEE;EACE,wDAAA;EACA,qDAAA;EACA,4DAAA;EACA,yDAAA;EACA,sEAAA;EACA,wEAAA;EACA;;;GAAA;EAIA,6DAAA;AACJ;AACI;EACE,iEAAA;EACA,6CAAA;EACA,kDAAA;EACA,qDAAA;AACN;AAEI;EACE,6DAAA;AAAN;AAGI;EACE,4CAAA;EACA,6CAAA;EACA,yDAAA;EACA,gDAAA;EACA,sDAAA;EACA,uCAAA;EACA,0CAAA;EACA,yCAAA;AADN;;AAMA;EAEE,8CAAA;AAJF;;AAOA;EACE,oBAAA;EACA,wBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,kBAAA;EACA,4BAAA;EAEA,gBAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,YAAA;AALF","sourcesContent":[":host {\n  background: var(--boxx-modal-header-background, #01091a);\n}\nion-header {\n  ion-toolbar {\n    --min-height: var(--boxx-modal-toolbar-min-height, 64px);\n    margin-top: var(--boxx-modal-toolbar-margin-top, 0px);\n    margin-bottom: var(--boxx-modal-toolbar-margin-bottom, -2px);\n    --padding-top: var(--boxx-modal-toolbar-padding-top, 0px);\n    border-top-left-radius: var(--boxx-modal-toolbar-topleft-radius, 10px);\n    border-top-right-radius: var(--boxx-modal-toolbar-topright-radius, 10px);\n    --background: var(\n      --boxx-modal-toolbar-background,\n      var(--boxx-app-background, white)\n    );\n    color: var(--boxx-modal-toolbar-color, var(--ion-text-color));\n\n    ::ng-deep ion-title {\n      margin-left: var(--boxx-modal-title-margin-left, 16px) !important;\n      padding: var(--boxx-modal-title-padding, 0px);\n      font-size: var(--boxx-modal-title-font-size, 17px);\n      font-weight: var(--boxx-modal-title-font-weight, 700);\n    }\n\n    ion-buttons[slot=\"end\"] {\n      margin-right: var(--boxx-modal-buttons-end-margin-right, 4px);\n    }\n\n    #grabber {\n      width: var(--boxx-modal-grabber-width, 36px);\n      height: var(--boxx-modal-grabber-height, 5px);\n      background: var(--boxx-modal-grabber-background, #c7c7cc);\n      margin: var(--boxx-modal-grabber-margin, 0 auto);\n      position: var(--boxx-modal-grabber-position, absolute);\n      top: var(--boxx-modal-grabber-top, 7px);\n      left: var(--boxx-modal-grabber-left, 15px);\n      right: var(--boxx-modal-grabber-right, 0);\n    }\n  }\n}\n\nion-content {\n  //position: var(--boxx-modal-content-position, absolute);\n  height: var(--boxx-modal-content-height, 100%);\n}\n\n#searchbar-wrapper {\n  --padding-start: 0px;\n  --inner-padding-end: 0px;\n}\n\nion-searchbar {\n  margin-left: 0px;\n  margin-right: 24px;\n  padding: 0px 10px !important;\n  //margin-top: 68px;\n  margin-top: 18px;\n}\n\nion-img{\n  width: 100%;\n}\n\n#loadMoreButton{\n  width: 100%;\n}\n\n.col-skeleton{\n  height: 75px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
